import React, { FC } from "react";
import { RouteComponentProps } from "@reach/router";

export const Guide: FC<Props> = props => {
  return <div>Guide</div>;
};

type Props = RouteComponentProps;
